import { render } from "./AffectationCategorieModal.vue?vue&type=template&id=6062bee7&scoped=true&ts=true"
import script from "./AffectationCategorieModal.vue?vue&type=script&lang=ts"
export * from "./AffectationCategorieModal.vue?vue&type=script&lang=ts"

import "./AffectationCategorieModal.vue?vue&type=style&index=0&id=6062bee7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6062bee7"]])

export default __exports__